import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// NOT: React.StrictMode kaldırıldı. StrictMode dev'de bileşenleri iki kez
// mount/unmount ediyor ve bu, @paypal/react-paypal-js'in PayPal düğmelerini
// boş (logosuz) render etmesine yol açıyordu. Üretimde StrictMode zaten
// çift-çağrı yapmaz; bu değişiklik yalnızca dev davranışını etkiler.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
